<ng-container *ngIf="vm$ | async as vm">
  
  <h1 class="head1">Zitting archief</h1>

  <div class="button__bar">
    <div>
      <button role="link" tabindex="0" title="Terug" type="button" class="btn btn-default" *ngIf="appService.routing.backHistoryItem"
        (click)="appService.routing.navigateBack()">{{appService.routing.backHistoryItem.title}}</button>
    </div>
    <select tabindex="0" title="Filter soort zitting" class="dropdown" [ngModel]="vm.soortZittingId" (ngModelChange)="soortZittingCmd.next($event)"
      name="soortZittingId">
      <option [ngValue]="null">Alle soorten zitting</option>
      <option [ngValue]="soortZitting.Id" *ngFor="let soortZitting of vm.soortenZitting">
        {{soortZitting.Omschrijving}}
      </option>
    </select>
  </div>

  <div class="jaren__row">
    <button role="link" title="Vorige acht jaren" (click)="navigateToPrevious(vm)" class="btn-icon jaar__item icon-arrow_left"></button>
    <button role="link" title="{{jaar}}" (click)="selectJaar(jaar)" class="btn-icon jaar__item"
      [ngClass]="vm.activeJaar==jaar ? 'btn-primary':'btn-default'" *ngFor="let jaar of vm.jaren">{{jaar}}
    </button>
    <button  role="link" title="Volgende acht jaren" tabindex="0" (click)="navigateToNext(vm)" class="btn-icon jaar__item icon-arrow_right"></button>
  </div>

  <div class="kalender__row">
    <app-zitting-list class="zittingen__row" [zittingen]="vm.zittingen"></app-zitting-list>
  </div>

</ng-container>